var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"grpTable",attrs:{"excel":_vm.isButton_(_vm.scrId, 'EX'),"paging":"","index":"","columns":_vm.cols,"rows":_vm.rows,"stripe":false,"selection":false,"customExcel":_vm.excelFunc,"pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }